var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "has-margin-top" }, [
    _c(
      "div",
      {
        staticClass: "bp-panel has-no-title",
        staticStyle: { "min-height": "auto" },
      },
      [
        _c("div", { staticClass: "panel-content" }, [
          _c(
            "div",
            { staticClass: "buttons has-addons mb-0" },
            _vm._l(_vm.publications, function (publication) {
              return _c(
                "button",
                {
                  key: publication.website.key,
                  staticClass: "button homepage-select-button",
                  class: {
                    "is-primary":
                      publication.website.key === _vm.selectedHomepage,
                  },
                  attrs: { title: _vm.statusNames[_vm.getStatus(publication)] },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("buttonAction", {
                        action: "switchHomepage",
                        element: publication.website.key,
                      })
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "homepage-select-status",
                    class: "is-" + _vm.getStatus(publication),
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(publication.website.name) +
                      "\n                "
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("p", { staticClass: "is-small-text mt-2" }, [
            _vm._v(
              "\n                Veröffentlichen und Kategorie gelten nur für die gewählte Homepage. Texte, Bilder, Tage und Preise gelten für alle Homepages.\n            "
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }